import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import onClickOutside from 'react-onclickoutside-decorator'
import { track } from 'app/modules/tracking/actions'
import { Button } from '@driftt/tide-core-legacy'
import POWER_ICON from '!svg-inline?removeTags=true!images/icons/bolt.svg'

const UPGRADE_HEADER = 'You’re on the Free plan which includes basic live chat and Drift meetings.'

class StatusPopOver extends Component {
  navigateToBilling = () => {
    track('Upgrade CTA Clicked')
    window.location.replace('/settings/billing')
  }

  render() {
    return (
      <div className="upgrade-pop-over">
        <div className="upgrade-message">
          <h3>Your plan</h3>
          <p>{UPGRADE_HEADER}</p>
          <Button onClick={this.navigateToBilling} className="upgrade-button-cta">
            <IconSVG src={POWER_ICON} className="upgrade-icon" />
            Get more Drift
          </Button>
        </div>
      </div>
    )
  }
}

export default onClickOutside(StatusPopOver)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/UpgradeStatus/StatusPopOver.js